// src/pages/PostProjectPage.jsx
import React from "react";
import PostProjectForm from "../components/PostProjectForm";

export default function PostProjectPage() {
  return (
    <div className="min-h-screen p-6 bg-black">
      <PostProjectForm />
    </div>
  );
}